import { useNavigate, useParams } from "react-router";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import { File, Folder } from "components/icons/generated";

import { getFileEditUrl } from "../../../helpers";
import { FileTreeNode } from "../../../fileTreeHelpers";
import useFilesNavigation from "../useFilesNavigation";
import styles from "./styles.module.css";

const NameCell = ({ item, ...cellProps }: TableSimpleCellProps<FileTreeNode>) => {
  const { repoId } = useParams<{ repoId: string }>();
  const navigate = useNavigate();
  const { goUp, setCurrentPath } = useFilesNavigation();

  if (item.type === "parent") {
    return (
      <TableSimpleCell {...cellProps} role="rowheader">
        <Box
          direction="row"
          align="center"
          gap="medium"
          onClick={goUp}
          className={styles.parentCell}
          fullWidth
        >
          <Icon src={Folder} noShrink />
          <Typography variant="p-body3" tag="span">
            ..
          </Typography>
        </Box>
      </TableSimpleCell>
    );
  }

  const isFolder = item.type === "folder";

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box direction="row" align="center" gap="medium">
        <Icon src={isFolder ? Folder : File} noShrink />
        {isFolder ? (
          <TableCellLink onPress={() => setCurrentPath(item.path.split("/"))}>
            {item.name}
          </TableCellLink>
        ) : (
          <TableCellLink onPress={() => navigate(getFileEditUrl(repoId!, item.path))}>
            {item.name}
          </TableCellLink>
        )}
      </Box>
    </TableSimpleCell>
  );
};

export default NameCell;
